export default __webpack_public_path__ + "static/media/fast-forward.84d6ef29.svg";